module.exports = __webpack_public_path__ + "static/media/logo-white-min.35169526.png";